const appName = process.env.REACT_APP_APPLICATION_NAME!;

/**
 * API for accessing firebase services (Authentication, Firestore, and Functions)
 * */
export class SFAuth {
  private static _instance: SFAuth;

  // Singleton
  private constructor() {}

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  async checkSession(): Promise<boolean> {
    const response = await fetch(`https://apps.silverfern.app/check-session?appName=${appName}`, {
      method: 'HEAD',
      credentials: 'include',
    });
    if (response.status === 200) {
      return true;
    }

    if (response.status === 401) {
      return false;
    }

    const err = new Error('Error checking session');
    throw err;
  }

  async fetchToken(): Promise<string> {
    const response = await fetch('https://apps.silverfern.app/desktop-token', {
      credentials: 'include',
    });
    if (response.status === 200) {
      const data = await response.text();
      return data;
    }

    const err = new Error('Error fetching token');
    throw err;
  }
}

const sfAuth = SFAuth.Instance;

export default sfAuth;
